import React from 'react'
import { Zoom } from '@material-ui/core'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

export default Transition
